import { selectModalOptions, useDappSelector } from "#/redux-state"

// eslint-disable-next-line import/prefer-default-export
export function useModalCustomOptions<T>() {
  return useDappSelector(selectModalOptions) as T
}
